import { pathOr } from "ramda";
export function mapResponse(publicProfile) {
    const name = pathOr(undefined, ["name", "value"], publicProfile);
    const image = pathOr(undefined, ["image", "value"], publicProfile);
    const headline = pathOr(undefined, ["headline", "value"], publicProfile);
    const verified = false;
    const profileResult = {
        name: name ? { value: name, verified } : undefined,
        image: image ? { url: image, verified } : undefined,
        headline: headline ? { value: headline, verified } : undefined,
    };
    return JSON.stringify(profileResult);
}
export const isIpfsAddress = (address) => (address === null || address === void 0 ? void 0 : address.toLocaleLowerCase().indexOf("ipfs")) > -1;
export const resolveIpfsAddressToGateway = (address, gatewayAddress) => {
    if (!address || !isIpfsAddress(address))
        return address;
    if (address.startsWith("ipfs://")) {
        return address.replace("ipfs/", "").replace("ipfs://", gatewayAddress);
    }
    return address.replace(/.*\/ipfs\//g, gatewayAddress);
};
export const filterServicesByTypeAndID = (services, serviceType, idFragment) => {
    return services.filter((s) => s.id.split("#").length > 1 &&
        s.id.split("#")[1] === idFragment &&
        s.type === serviceType);
};
